export const VIDEOCALL_INCOMING_SHOW = 'VIDEOCALL.INCOMING.SHOW'
export const VIDEOCALL_INCOMING_HIDE = 'VIDEOCALL.INCOMING.HIDE'
export const VIDEOCALL_INCALL_STARTED = 'VIDEOCALL.INCALL.STARTED'
export const VIDEOCALL_INCALL_ENDED = 'VIDEOCALL.INCALL.ENDED'
export const VIDEOCALL_DROPPED = 'VIDEOCALL.DROPPED'
